import { message } from 'antd'
import Fee from '../../../../components/Purchasing/Order/Fee/Fee'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'
import { pick } from 'lodash'
import React from 'react'
import { OrdersApi } from '../../../../api/Purchase/Orders'

function FeeCont(props) {
  const { order, isUpdatable } = props
  console.log({ isUpdatable })
  let { list, fetching, fetch } = useFetchList(() => OrdersApi.getLinesByOrder(order._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    // remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
    isNew,
  } = useModalData(OrdersApi.lines.create, OrdersApi.lines.update, OrdersApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await OrdersApi.lines.create({
        ...newObject,
        purchases: pick(order, ['_key', '_id', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function remove() {
    setSubmitting(true)
    try {
      await OrdersApi.lines.remove({
        ...pick(line, ['_id', '_rev', '_key']),
        purchases: pick(order, ['_key', '_id', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <Fee
      {...{
        list,
        isNew,
        fetching,
        fetch,
        visible,
        submitting,
        line,
        order,
        onShow,
        onCancel,
        checkForm,
        submit,
        removing,
        remove,
        update,
        modalType,
        isUpdatable,
        formRef,
      }}
    />
  )
}

export default FeeCont
